import { api } from "./api";

export const getConfig = () => api.get("/config");
export const salvarConfig = (dto) => api.post("/config", dto);
export const testarEmail = (para) => api.post("/config/testar-email", { Para: para });
export const testarWhatsappCfg = (celular, templateId) =>
  api.post("/config/testar-whatsapp", { Celular: celular, TemplateId: templateId });
export const testarPix = ({ cpf, val, mat, bol, provedor } = {}) =>
  api.post("/config/testar-pix", {
    Cpf: cpf, Valor: val ? Number(String(val).replace(",", ".")) : null,
    Matricula: mat, CodigoBoleto: bol,
    Provedor: provedor || null,   // vazio = provedor padrão do sistema
  });
export const testarMatricula = (cpf) => api.post("/config/testar-matricula", { Cpf: cpf });

// Webhook PIX do Banco do Brasil
export const registrarWebhookBB = (url) => api.post("/config/webhook-bb/registrar", { Url: url });
export const consultarWebhookBB = () => api.get("/config/webhook-bb");
export const excluirWebhookBB = () => api.delete("/config/webhook-bb");
